/* v8 ignore start */
export const assertNever = x => x;
/* v8 ignore stop */